import { PlatformSlug } from 'constants/consts'
import { enabledOn, isFeatureAvailable } from 'platformConfig'

export const INSTITUTIONAL_CODES_CONFIG = enabledOn(
  PlatformSlug.DATBooster,
  PlatformSlug.OATBooster,
  PlatformSlug.INBDEBooster
)

export const isInstitutionalCodesAvailable = (slug?: PlatformSlug) =>
  isFeatureAvailable(INSTITUTIONAL_CODES_CONFIG, slug)
